/*! mini-$ v1 -- the 11 jQuery idioms this theme actually uses.
    Replaces jQuery 3.7.1 (30 KiB + the code.jquery.com origin) with ~2 KiB served
    from our own CDN. Call sites are unchanged by design: the blast radius of this
    swap is THIS FILE, not 35 edits across cart/collection/same-day-order/base.
    Idioms covered: $(sel) $(el) $(document).ready .length .val .text .addClass
    .removeClass .on .click .focus .prop .serialize $.ajax                        */
(function (w, d) {
  function C(nodes) { this.nodes = nodes; this.length = nodes.length; }
  C.prototype = {
    each: function (fn) { this.nodes.forEach(fn); return this; },
    val: function (v) {
      if (v === undefined) { var n = this.nodes[0]; return n ? n.value : undefined; }
      return this.each(function (n) { n.value = v; });
    },
    text: function (v) {
      if (v === undefined) return this.nodes[0] ? this.nodes[0].textContent : undefined;
      return this.each(function (n) { n.textContent = v; });
    },
    addClass: function (c) {
      var cs = String(c).split(/\s+/).filter(Boolean);
      return this.each(function (n) { n.classList.add.apply(n.classList, cs); });
    },
    removeClass: function (c) {
      var cs = String(c).split(/\s+/).filter(Boolean);
      return this.each(function (n) { n.classList.remove.apply(n.classList, cs); });
    },
    on: function (types, fn) {
      var ts = String(types).split(/\s+/).filter(Boolean);
      return this.each(function (n) {
        ts.forEach(function (t) { n.addEventListener(t, function (e) { fn.call(n, e); }); });
      });
    },
    click: function (fn) {
      return fn ? this.on('click', fn) : this.each(function (n) { n.click(); });
    },
    focus: function () { if (this.nodes[0]) this.nodes[0].focus(); return this; },
    prop: function (k, v) {
      if (v === undefined) return this.nodes[0] ? this.nodes[0][k] : undefined;
      return this.each(function (n) { n[k] = v; });
    },
    serialize: function () {
      var f = this.nodes[0];
      return f ? new URLSearchParams(new FormData(f)).toString() : '';
    },
    ready: function (fn) {
      if (d.readyState !== 'loading') fn();
      else d.addEventListener('DOMContentLoaded', function () { fn(); });
      return this;
    }
  };
  function $(sel) {
    if (sel instanceof C) return sel;
    if (typeof sel === 'function') return new C([d]).ready(sel);
    if (typeof sel === 'string') return new C(Array.prototype.slice.call(d.querySelectorAll(sel)));
    if (sel === d || sel === w) return new C([sel]);
    if (sel && sel.nodeType) return new C([sel]);
    if (sel && sel.length !== undefined) return new C(Array.prototype.slice.call(sel));
    return new C([]);
  }
  $.ajax = function (o) {
    o = o || {};
    var url = o.url;
    var opt = {
      method: (o.type || o.method || 'GET').toUpperCase(),
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'   // the cart session cookie MUST ride along
    };
    if (o.data !== undefined) {
      var enc = (typeof o.data === 'string') ? o.data : new URLSearchParams(o.data).toString();
      if (opt.method === 'GET') { url += (url.indexOf('?') < 0 ? '?' : '&') + enc; }
      else {
        opt.body = enc;
        opt.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      }
    }
    return fetch(url, opt).then(function (r) {
      var ct = r.headers.get('content-type') || '';
      var wantJson = (o.dataType === 'json') || ct.indexOf('json') >= 0;
      return (wantJson ? r.json().catch(function () { return null; }) : r.text())
        .then(function (body) {
          if (!r.ok) throw Object.assign(new Error('HTTP ' + r.status), { status: r.status, body: body });
          if (o.success) o.success(body, 'success', r);
          return body;
        });
    }).catch(function (err) { if (o.error) o.error(err); else throw err; });
  };
  if (!w.$) w.$ = $;
  if (!w.jQuery) w.jQuery = $;
})(window, document);
